import { IOrganization, OrganizationStatusEnum } from './organization.model';

export enum UserRolesEnum {
  Admin = 'admin',
  Investor = 'investor',
  Member = 'member',
  Notary = 'notary'
}

type UserRole =
  UserRolesEnum.Admin |
  UserRolesEnum.Investor |
  UserRolesEnum.Member |
  UserRolesEnum.Notary;

export interface IUserBalance {
  blocks: number;
  certificates: number;
  value: number;
  soldCertificates: number;
  soldCertificatesValue: number;
  inTradeCertificates: number;
  inTradeCertificatesValue: number;
}

export interface IUserSlim {
  id?: number;
  initials: string;
  firstName: string;
  lastName: string;
  email: string;
  blocks: number;
  certificates: number;
  value: number;
  paid: boolean;
  certificatesBalance: number;
  organizationDateOfJoining: string;
}

export interface IUser extends IUserSlim {
  accessToken: string;
  expires: string;
  issued: string;
  role: UserRole;
  organizationName: string;
  organizationStatus: OrganizationStatusEnum;
  organization: IOrganization;
}

export interface IUserLogin {
  userName: string;
  password: string;
}

export interface IVerifyRequest {
  id: string;
  code: string;
}

export enum LoginResult {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
  MFA_REQUIRED = 'MFA_REQUIRED',
  MOBILE_PHONE_NOT_FOUND = 'MOBILE_PHONE_NOT_FOUND',
  SMS_SEND_FAILED = 'SMS_SEND_FAILED'
}

export enum VerifyResult {
  SUCCESS = 'SUCCESS',
  WRONG_CODE = 'WRONG_CODE',
  MFA_EXPIRED = 'MFA_EXPIRED',
  FAILED = 'FAILED'
}

export interface ILoginResponse {
  result: LoginResult;
  token?: IUser;
  mfaId?: string;
  mfaContact?: string;
  mfaBySms?: boolean;
}

export interface IVerifyResponse {
  result: VerifyResult;
  token?: IUser;
}
